import { css } from '@emotion/react';

export const useStyles = () => {
  return {
    icons: css`
      display: flex;
      justify-content: right;
      align-items: center;
      width: 100%;
      gap: 24px;
      margin-right: 24px;
    `,
    header: css`
      display: flex;
      align-items: center;
      width: 100%;
    `,
    wrapper: css`
      margin-bottom: 12px;
    `,
  };
};
